import { FC } from "react"
import { SubAdminSetting } from "../../../../module/settings/containers/subAdmin/setting"

export const SubAdminSettingPage: FC = () => <SubAdminSetting />
